module.exports = __webpack_public_path__ + "img/programa_asignatura.a5e86bb9.png";